(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xyg-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = new Map();
    const setup = (root) => {
      if (!root || roots.has(root)) return;
      const track = root.querySelector('[data-xyg-hero-track]');
      const slides = [...root.querySelectorAll('[data-xyg-hero-slide]')];
      const dots = [...root.querySelectorAll('[data-xyg-hero-dot]')];
      const previous = root.querySelector('[data-xyg-hero-previous]');
      const next = root.querySelector('[data-xyg-hero-next]');
      const pause = root.querySelector('[data-xyg-hero-pause]');
      const pauseIcon = root.querySelector('[data-xyg-hero-pause-icon]');
      const status = root.querySelector('[data-xyg-hero-status]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const canAutoplay = root.dataset.autoplay === 'true' && !reducedMotion && slides.length > 1;
      const delay = Math.max(Number(root.dataset.delay) || 5000, 4000);
      let activeIndex = 0;
      let timer;
      let paused = false;
      let scrollFrame;

      const stop = () => window.clearTimeout(timer);
      const setPauseState = () => {
        if (!pause) return;
        pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        if (pauseIcon) pauseIcon.textContent = paused ? '▶' : 'Ⅱ';
      };
      const schedule = () => {
        stop();
        if (!canAutoplay || paused || document.hidden) return;
        timer = window.setTimeout(() => move(activeIndex + 1), delay);
      };
      const update = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.inert = !isActive;
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
      };
      const move = (index, behavior = 'smooth') => {
        const targetIndex = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[targetIndex].offsetLeft, behavior: reducedMotion ? 'auto' : behavior });
        update(targetIndex);
        schedule();
      };
      const syncToScroll = () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const index = slides.reduce((closest, slide, slideIndex) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[closest].offsetLeft - track.scrollLeft) ? slideIndex : closest, 0);
          if (index !== activeIndex) update(index);
          schedule();
        });
      };

      previous?.addEventListener('click', () => move(activeIndex - 1));
      next?.addEventListener('click', () => move(activeIndex + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => move(Number(dot.dataset.index))));
      pause?.addEventListener('click', () => {
        paused = !paused;
        setPauseState();
        if (paused) stop(); else schedule();
      });
      track.addEventListener('scroll', syncToScroll, { passive: true });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', schedule);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) schedule(); });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(activeIndex - 1);
        if (event.key === 'ArrowRight') move(activeIndex + 1);
      });
      const visibilityHandler = () => { if (document.hidden) stop(); else schedule(); };
      document.addEventListener('visibilitychange', visibilityHandler);
      update(0);
      setPauseState();
      schedule();
      roots.set(root, { stop, visibilityHandler });
    };
    const destroy = (root) => {
      const instance = roots.get(root);
      if (!instance) return;
      instance.stop();
      document.removeEventListener('visibilitychange', instance.visibilityHandler);
      roots.delete(root);
    };
    const setupAll = (scope = document) => scope.querySelectorAll('[data-xyg-hero]').forEach(setup);
    setupAll();
    document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-xyg-hero]').forEach(destroy));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-xyg-hero-slide]');
      if (!slide) return;
      const root = slide.closest('[data-xyg-hero]');
      const slides = [...root.querySelectorAll('[data-xyg-hero-slide]')];
      const index = slides.indexOf(slide);
      const dot = root.querySelector(`[data-xyg-hero-dot][data-index="${index}"]`);
      dot?.click();
      const pause = root.querySelector('[data-xyg-hero-pause]');
      if (pause?.getAttribute('aria-pressed') === 'false') pause.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xyg-home-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSlider = (slider) => {
      if (!slider || slider.dataset.xygSliderReady === 'true') return;

      const slides = Array.from(slider.querySelectorAll('[data-xyg-home-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-xyg-home-dot]'));
      const previousButton = slider.querySelector('[data-xyg-home-prev]');
      const nextButton = slider.querySelector('[data-xyg-home-next]');
      const pauseButton = slider.querySelector('[data-xyg-home-pause]');
      const pauseIcon = slider.querySelector('[data-xyg-home-pause-icon]');
      const status = slider.querySelector('[data-xyg-home-status]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = slider.dataset.autoplay === 'true' && !reduceMotion && slides.length > 1;
      const delay = Math.max(Number(slider.dataset.delay) || 6000, 4000);

      let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
      let timer;
      let userPaused = false;
      let pointerStartX;

      const updatePauseButton = () => {
        if (!pauseButton) return;
        const label = userPaused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel;
        pauseButton.setAttribute('aria-label', label);
        pauseButton.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        if (pauseIcon) pauseIcon.textContent = userPaused ? '▶' : 'Ⅱ';
      };

      const stopTimer = () => {
        window.clearTimeout(timer);
      };

      const startTimer = () => {
        stopTimer();
        if (!autoplay || userPaused || document.hidden) return;
        timer = window.setTimeout(() => showSlide(activeIndex + 1, false), delay);
      };

      const showSlide = (requestedIndex, restart = true) => {
        const nextIndex = (requestedIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const isActive = index === nextIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          slide.inert = !isActive;
        });
        dots.forEach((dot, index) => {
          const isActive = index === nextIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        activeIndex = nextIndex;
        if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
        if (restart) startTimer();
        else {
          stopTimer();
          startTimer();
        }
      };

      previousButton?.addEventListener('click', () => showSlide(activeIndex - 1));
      nextButton?.addEventListener('click', () => showSlide(activeIndex + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.slideIndex))));

      pauseButton?.addEventListener('click', () => {
        userPaused = !userPaused;
        updatePauseButton();
        if (userPaused) stopTimer();
        else startTimer();
      });

      slider.addEventListener('mouseenter', stopTimer);
      slider.addEventListener('mouseleave', startTimer);
      slider.addEventListener('focusin', stopTimer);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) startTimer();
      });
      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
        if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
      });
      slider.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') pointerStartX = event.clientX;
      });
      slider.addEventListener('pointerup', (event) => {
        if (pointerStartX === undefined || event.pointerType === 'mouse') return;
        const movement = event.clientX - pointerStartX;
        pointerStartX = undefined;
        if (Math.abs(movement) < 48) return;
        showSlide(activeIndex + (movement < 0 ? 1 : -1));
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopTimer();
        else startTimer();
      });

      slider.dataset.xygSliderReady = 'true';
      updatePauseButton();
      startTimer();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-xyg-home-slider]').forEach(initializeSlider);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xyg-page-suite"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-xyg-stockists]').forEach((section) => {
    const input = section.querySelector('[data-xyg-stockist-search]');
    const clear = section.querySelector('[data-xyg-stockist-clear]');
    const cards = [...section.querySelectorAll('[data-xyg-stockist]')];
    const count = section.querySelector('[data-xyg-stockist-count]');
    const empty = section.querySelector('[data-xyg-stockist-empty]');
    if (!input) return;
    const filter = () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const match = !query || (card.dataset.search || '').includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (count) count.textContent = visible;
      if (empty) empty.hidden = visible !== 0;
    };
    input.addEventListener('input', filter);
    clear?.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xyg-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-xyg-product]').forEach((section) => {
    if (section.dataset.xygBound === 'true') return;
    section.dataset.xygBound = 'true';

    const gallery = section.querySelector('[data-xyg-gallery]');
    const galleryImage = gallery?.querySelector('[data-xyg-main-image]');
    const galleryThumbs = Array.from(gallery?.querySelectorAll('[data-xyg-thumb]') || []);
    const activateThumb = (button, scrollToGallery = false) => {
      if (!button || !galleryImage) return;
      galleryImage.removeAttribute('srcset');
      galleryImage.removeAttribute('sizes');
      galleryImage.src = button.dataset.xygSrc;
      galleryImage.alt = button.dataset.xygAlt || '';
      galleryThumbs.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      if (scrollToGallery && window.matchMedia('(max-width: 989px)').matches) {
        gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    galleryThumbs.forEach((button) => {
      button.addEventListener('click', () => activateThumb(button));
    });

    const stickyPrice = section.querySelector('[data-xyg-sticky-price]');
    section.querySelectorAll('input[name="id"]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        if (stickyPrice) stickyPrice.textContent = input.dataset.xygPrice;
        const matchingThumb = galleryThumbs.find((thumb) => thumb.dataset.xygVariant === input.value);
        activateThumb(matchingThumb, true);
      });
    });

  });

  } catch(e) { console.error(e); }
})();
})();
